export default {
    bindRvNotice: '/api/lp/vehicle/bindRvNotice',
    unplanVehicleQueryBindedRvNotice: '/api/lp/vehicle/unplanVehicleQueryBindedRvNotice',
    getAndCheckUnBindVehicleAssignmentMessage: '/api/lp/vehicle/getAndCheckUnBindVehicleAssignmentMessage',
    unplanVehicleCancelBindRvNotice: '/api/lp/vehicle/unplanVehicleCancelBindRvNotice',
    createUnPlanVehicle: '/api/lp/vehicle/createUnPlanVehicle',
};
